<template>
  <div class="notice-container">
    <div class="heading-icon" style="background-color: #2a9d8f">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
        <polyline points="14,2 14,8 20,8"></polyline>
        <line x1="16" y1="13" x2="8" y2="13"></line>
        <line x1="16" y1="17" x2="8" y2="17"></line>
        <polyline points="10,9 9,9 8,9"></polyline>
      </svg>
    </div>
    <h1 class="title-with-underline">體檢／健檢掛號須知</h1>

    <div class="notice-content">
      <p class="notice-subtitle">
        攸關您的就診權益，在進行掛號前請詳細閱讀
      </p>

      <ol class="notice-list">
        <li class="notice-item">
          <div class="notice-item-title">1. 完成線上掛號後，看診當日請記得攜帶健保卡、身分證前至掛號櫃檯現場報到</div>
        </li>

        <li class="notice-item">
          <div class="notice-item-title">2. 最晚報到時間為：<span class="highlight-text">11:00 (上午診)</span>、<span class="highlight-text">5:00 (下午診)</span>、<span class="highlight-text">9:00 (夜診)</span></div>
        </li>

        <li class="notice-item">
          <div class="notice-item-title">3. 當日不開放網路預約，若預約額滿，請至現場掛號</div>
        </li>

        <li class="notice-item">
          <div class="notice-item-title">4. 為維護看診品質，現場報到情況限制看診人數，建議提早掛號</div>
        </li>
      </ol>
    </div>
  </div>
</template>

<script>
// import Checkboxes from '@/components/web/proj/tongxin-demo/common/Checkboxes.vue'

export default {
  name: 'Notice',
  // components: { Checkboxes },
  model: { prop: 'value', event: 'input' },
  props: {
    value: { type: Array, default: () => [] },
    options: { type: Array, default: () => [] },
    baseFee: { type: Number, default: 0 }
  },
  computed: {
    proxy: {
      get() {
        return Array.isArray(this.value) ? this.value : []
      },
      set(v) {
        this.$emit('input', Array.isArray(v) ? v : [])
      }
    },
    selectedAddOns() {
      const set = new Set((this.value || []).map(v => String(v)))
      return (this.options || []).filter(o => set.has(String(o.value)))
    },
    addOnTotal() {
      return this.selectedAddOns.reduce((sum, item) => sum + (item.price || 0), 0)
    },
    totalCost() {
      return (this.baseFee || 0) + this.addOnTotal
    }
  }
}
</script>

<style scoped>
/* 須知內容區域 */
.notice-content {
  background: #f8f9fa;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 24px;
}

.notice-subtitle {
  font-size: 16px;
  color: #666;
  margin-bottom: 20px;
  text-align: center;
  font-style: italic;
}

.notice-list {
  list-style: none;
  padding: 0;
}

.notice-item {
  margin-bottom: 24px;
  padding: 16px;
  background: #fff;
  border-radius: 8px;
  border-left: 4px solid #2a9d8f;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.notice-item:last-child {
  margin-bottom: 0;
}

.notice-item-title {
  font-size: 18px;
  font-weight: bold;
  color: #207868;
  margin-bottom: 8px;
  line-height: 1.4;
}

.notice-item-content {
  font-size: 16px;
  color: #555;
  line-height: 1.6;
}

.highlight-text {
  color: #207868;
  font-weight: bold;
}

@media screen and (max-width: 768px) {
  .notice-content {
    padding: 16px;
  }

  .notice-item {
    padding: 12px;
    margin-bottom: 16px;
  }

  .notice-item-title {
    font-size: 16px;
  }

  .notice-item-content {
    font-size: 14px;
  }

  .notice-subtitle {
    font-size: 14px;
  }
}
</style>
